import keymirror from 'keymirror';

const DraggableItemTypes = keymirror({
  SURVEY_EDITOR_BLOCK: null,
  SURVEY_EDITOR_PAGE_BREAK: null,
  SURVEY_EDITOR_SECTION_HEADER: null,
  INLINE_OPTION_EDITOR: null,
  IMAGE_ITEM_EDITOR: null,
  MATRIX_ROW_EDITOR: null,
});

export default DraggableItemTypes;
